import { connect } from 'react-redux'
import ServiceWorkingHoursItemComponent from '../../components/services/edit/working-hours/ServiceWorkingHoursItem'
import { actionCreators, removeServiceDaysHours } from '../../state/actions/services/index'
import { IStoreState, IWorkingHoursItem } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    workingHoursItem: ownProps.workingHoursItem
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onRemoveClick: (id: string) => dispatch(removeServiceDaysHours(id)),
    onSetFrom: (workingHoursId: string, from: string) =>
      dispatch(actionCreators.workingHoursSetFrom(workingHoursId, from)),
    onSetUntil: (workingHoursId: string, until: string) =>
      dispatch(actionCreators.workingHoursSetUntil(workingHoursId, until)),
    onSetDays: (workingHoursId: string, days: string[]) =>
      dispatch(actionCreators.workingHoursSetDays(workingHoursId, days))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceWorkingHoursItemComponent)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceWorkingHoursItem.ts